// @ts-nocheck
(function () {
  const dock = document.querySelector('[data-dock]');
  if (!dock) return;

  // Prefixo de idioma (mesma lógica do menu): Shopify.routes.root = "/fr/" em FR.
  function currentLocalePrefix() {
    if (window.Weglot && typeof window.Weglot.getCurrentLang === "function") {
      try {
        const l = window.Weglot.getCurrentLang();
        if (l && l.toLowerCase() !== "en") return "/" + l.toLowerCase();
        if (l && l.toLowerCase() === "en") return "";
      } catch (e) {}
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const rootPrefix = root.replace(/\/+$/, "");
    if (rootPrefix) return rootPrefix;
    const seg = window.location.pathname.split("/").filter(Boolean)[0] || "";
    if (/^[a-z]{2}(-[a-z]{2})?$/i.test(seg) && seg.toLowerCase() !== "en") {
      return "/" + seg.toLowerCase();
    }
    return "";
  }

  function localizedPath(path) {
    if (!path) return path;
    const prefix = currentLocalePrefix();
    if (!prefix) return path;
    let origin = "", p = path, rest = "";
    if (/^https?:\/\//i.test(path)) {
      try {
        const u = new URL(path);
        if (u.hostname !== window.location.hostname) return path;
        origin = u.origin; p = u.pathname; rest = u.search + u.hash;
      } catch (e) { return path; }
    } else if (!path.startsWith("/")) {
      return path;
    }
    if (p === prefix || p.startsWith(prefix + "/")) return path;
    return origin + prefix + p + rest;
  }

  const trigger = dock.querySelector('[data-search-trigger]');
  const panel = dock.querySelector('[data-dock-search-panel]');
  const input = panel?.querySelector('input.dock-search-input');
  const results = panel?.querySelector('.dock-search-results');
  const statusEl = panel?.querySelector('.dock-search-status');
  const closeBtn = panel?.querySelector('.dock-search-close');
  const viewAll = panel?.querySelector('.dock-search-viewall');
  const searchPanel = dock.querySelector('.dock-panel--search');

  const menuPanel = dock.querySelector('[data-dock-panel]');

  function matchNavWidth() {
    const nav = dock.querySelector('.dock__nav');
    if (!nav || !searchPanel || !menuPanel) return;

    let navWidth = '';

    function applyMenuWidth() {
      if (menuPanel.classList.contains('is-bespoke-mode')) {
        menuPanel.style.width = '';
      } else if (menuPanel.classList.contains('is-open')) {
        menuPanel.style.width = navWidth;
      }
    }

    new ResizeObserver(([entry]) => {
      navWidth = entry.contentRect.width + entry.contentRect.x * 2 + 'px';
      searchPanel.style.width = navWidth;
      applyMenuWidth();
    }).observe(nav);

    new MutationObserver(applyMenuWidth).observe(menuPanel, { attributes: true, attributeFilter: ['class'] });
  }
  if (!trigger || !panel || !input || !results || !statusEl || !closeBtn || !viewAll) return;

  matchNavWidth();

  let abortCtrl = null;
  let lastQuery = '';

  // ===== Carrossel: 4 visíveis, desliza 1 a 1 =====
  const VISIBLE = 4;
  let allProducts = [];
  let index = 0;

  const viewport = document.createElement('div');
  viewport.className = 'dock-results-viewport';

  const track = document.createElement('div');
  track.className = 'dock-results-track';
  viewport.appendChild(track);
  results.appendChild(viewport);

  const navPrev = document.createElement('button');
  navPrev.type = 'button';
  navPrev.className = 'dock-results-nav dock-results-nav--prev';
  navPrev.setAttribute('aria-label', 'Previous');
  navPrev.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const navNext = document.createElement('button');
  navNext.type = 'button';
  navNext.className = 'dock-results-nav dock-results-nav--next';
  navNext.setAttribute('aria-label', 'Next');
  navNext.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  results.appendChild(navPrev);
  results.appendChild(navNext);

  function maxIndex() {
    return Math.max(0, allProducts.length - VISIBLE);
  }

  function updateNav() {
    const show = allProducts.length > VISIBLE;
    navPrev.style.display = show ? 'inline-flex' : 'none';
    navNext.style.display = show ? 'inline-flex' : 'none';
    navPrev.disabled = index <= 0;
    navNext.disabled = index >= maxIndex();
  }

  function applyTransform() {
    // cada slide ocupa 1/VISIBLE da largura do viewport
    const step = 100 / VISIBLE;
    track.style.transform = `translateX(-${index * step}%)`;
    updateNav();
  }

  function renderAll() {
    track.innerHTML = allProducts.map(p => {
      const img = p.image || '';
      const sub = [p.vendor, p.product_type].filter(Boolean).join(' / ');
      return `
        <a class="dock-result-card" href="${localizedPath(p.url)}" role="listitem">
          <div class="dock-result-img">${img ? `<img src="${img}" alt="">` : ''}</div>
          <div class="dock-result-info">
            <div class="dock-result-title">${escapeHtml(p.title)}</div>
            <div class="dock-result-sub">${escapeHtml(sub)}</div>
          </div>
        </a>
      `;
    }).join('');

    index = 0;
    track.style.transition = 'none';
    applyTransform();
    // reativa a transição no frame seguinte
    requestAnimationFrame(() => {
      track.style.transition = '';
    });
  }

  navPrev.addEventListener('click', (e) => {
    e.preventDefault();
    if (index > 0) { index--; applyTransform(); }
  });

  navNext.addEventListener('click', (e) => {
    e.preventDefault();
    if (index < maxIndex()) { index++; applyTransform(); }
  });

  function clearResults() {
    allProducts = [];
    index = 0;
    track.innerHTML = '';
    track.style.transform = '';
    updateNav();
  }

  function open() {
    if (menuPanel) {
      menuPanel.classList.remove('is-open');
      menuPanel.setAttribute('aria-hidden', 'true');

      dock.querySelectorAll('[data-dock-item]').forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => input?.focus(), 0);
  }

  function close() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    panel.classList.contains('is-open') ? close() : open();
  });

  closeBtn.addEventListener('click', () => {
    input.value = '';
    closeBtn.classList.remove('is-visible');
    search('');
    close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('click', (e) => {
    if (!panel.classList.contains('is-open')) return;
    if (!panel.contains(e.target) && !trigger.contains(e.target)) close();
  });

  function debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  async function search(q) {
    const query = q.trim();
    searchPanel.classList.remove('has-results');
    lastQuery = query;

    if (!query) {
      statusEl.textContent = '';
      clearResults();
      viewAll.href = localizedPath('/search');
      return;
    }

    viewAll.href = localizedPath(`/search?q=${encodeURIComponent(query)}`);

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const url =
      `/search/suggest.json?q=${encodeURIComponent(query)}` +
      `&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;

    let data;
    try {
      const res = await fetch(url, { signal: abortCtrl.signal });
      data = await res.json();
    } catch (e) {
      if (e.name === 'AbortError') return;
      statusEl.textContent = '';
      clearResults();
      return;
    }

    const products = data?.resources?.results?.products || [];

    if (query !== lastQuery) return;

    if (!products.length) {
      searchPanel.classList.remove('has-results');
      statusEl.textContent = '0 items found';
      clearResults();
      return;
    }

    searchPanel.classList.add('has-results');
    statusEl.textContent = `${products.length} item${products.length !== 1 ? 's' : ''} found`;

    allProducts = products;
    renderAll();
  }

  input.addEventListener('input', debounce(() => {
    const val = input.value;
    closeBtn.classList.toggle('is-visible', val.length > 0);
    search(val);
  }, 180));

  input.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const q = input.value.trim();
    if (!q) return;
    window.location.href = localizedPath(`/search?q=${encodeURIComponent(q)}`);
  });

  viewAll.addEventListener('click', (e) => {
    const q = input.value.trim();
    if (!q) return;
    e.preventDefault();
    window.location.href = localizedPath(`/search?q=${encodeURIComponent(q)}`);
  });
})();